<template>
    <v-container class="fill-height justify-start align-start">
        <v-row>
            <v-col>
                <v-form v-model="valid">
                    <v-card>
                        <v-toolbar>
                            <v-toolbar-title>{{ title }}</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field label="Name" variant="outlined" v-model="name"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn variant="elevated" class="ml-2 mr-3" @click="$router.push('/defects')">Back</v-btn>
                            <v-btn variant="elevated" color="primary" class="mr-3" @click="save">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-col>
        </v-row>
        <v-snackbar v-model="snackbar">{{ message }}
            <template v-slot:actions>
                <v-btn icon="mdi-close" variant="text" @click="snackbar = false" :timeout="timeout"></v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>

import DefectApi from '../services/DefectApi'

export default {
    name: 'DefectEdit',
    data() {
        return {
            id: '',
            valid: false,
            name: "",
            title: '',
            stateItems: ['Active', 'Inactive'],
            state: 'Active',
            snackbar: false,
            message: "",
            timeout: 2000,
        }
    },
    mounted() {
        this.id = this.$route.params.id;

        if (!isNaN(this.id)) {
            this.title = "Edit";
            DefectApi.get(this.id).then((response) => {
                if (response && response.data) {
                    this.defectId = response.data.defectId;
                    this.name = response.data.name;
                }
            })
        }
        else {
            this.title = "Create";
        }
    },
    methods: {
        save() {
            if (!isNaN(this.id)) {
                let payload = {
                    defectId: this.id,
                    name: this.name
                };
                DefectApi.put(this.id, payload).then((response) => {
                    if (response && response.data) {
                        this.message = response.data.state.message;
                        this.snackbar = true;
                    }
                })
            }
            else {
                let body = {
                    name: this.name
                };
                DefectApi.post(body).then((response) => {
                    if (response && response.data) {
                        this.id = response.data.defectId;
                        this.$router.push(`/defects/${this.id}`);

                        this.message = response.data.state.message;
                        this.snackbar = true;
                    }
                })
            }
        }
    }
}
</script>